var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"OnOff",class:_vm.value?'On':'Off',style:({width:_vm.width}),attrs:{"disabled":_vm.disabled},on:{"click":_vm.toggleYesNo}},[_c('span',{staticClass:"lblOnOff"},[_c('div',{staticClass:"OnOffFucus",attrs:{"contenteditable":"true"},on:{"keydown":_vm.onOffFucusKeyDown}}),_vm._v("\n    "+_vm._s(_vm.getLabel)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63772d5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ekkControls/OnOff.vue
// module id = null
// module chunks = 